import Icon from '../components/Icon.vue'

Icon.register({"file-medical":{"width":384,"height":512,"paths":[{"d":"M377 105L279.1 7C274.6 2.5 268.5 0 262.1 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105zM224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM288 296V344C288 348.4 284.4 352 280 352H224V408C224 412.4 220.4 416 216 416H168C163.6 416 160 412.4 160 408V352H104C99.6 352 96 348.4 96 344V296C96 291.6 99.6 288 104 288H160V232C160 227.6 163.6 224 168 224H216C220.4 224 224 227.6 224 232V288H280C284.4 288 288 291.6 288 296z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-medical.js
// module id = Uivh
// module chunks = 0